import { createSlice } from '@reduxjs/toolkit';
import { defaultState } from './data/ServerMaintenanceState';

export const slice = createSlice({
  name: 'server-maintenance',
  initialState: defaultState,
  reducers: {
    setServerMaintenanceActive: (draft) => {
      draft.isActive = true;
    },
  },
});

export const { setServerMaintenanceActive } = slice.actions;
export default slice.reducer;
